import React, { FC } from "react";
import { Button } from "../../components";
import { useAppDispatch, useAppSelector } from "../../store";
import appConfig from "../../util/appConfig";
import { updateAdminEigentuemerwechselItemStatusById } from "../../store/slices/eigentuemerwechsel";

interface IMags {
  itemId: string;
}

const Mags: FC<IMags> = ({ itemId }) => {
  const dispatch = useAppDispatch();
  const { eigentuemerwechselItem } = useAppSelector(
    (state) => state.eigentuemerwechsel.admin,
  );

  if (!eigentuemerwechselItem) {
    return null;
  }

  if (eigentuemerwechselItem && eigentuemerwechselItem?.status === "accepted") {
    return null;
  }

  return (
    <div
      style={{
        // textAlign: "end",
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
      }}
    >
      {["check"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="Zu bearbeiten"
          width="200"
          isOutlined
          outlineColor={appConfig.secondaryColor || appConfig.mainColor}
          textColor={appConfig.secondaryColor || appConfig.mainColor}
          onClick={() => {
            if (itemId) {
              dispatch(
                updateAdminEigentuemerwechselItemStatusById({
                  id: itemId,
                  status: "inWork",
                }),
              );
            }
          }}
        />
      ) : null}
      {["inWork"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="Fertig"
          width="200"
          backgroundColor={appConfig.mainColor}
          onClick={() => {
            if (itemId) {
              dispatch(
                updateAdminEigentuemerwechselItemStatusById({
                  id: itemId,
                  status: "accepted",
                }),
              );
            }
          }}
        />
      ) : null}
      {!["accepted"].includes(eigentuemerwechselItem?.status ?? "") ? (
        <Button
          text="Stornieren"
          width="200"
          backgroundColor="white"
          isOutlined
          outlineColor={"red"}
          textColor={"red"}
          onClick={() => {
            if (itemId) {
              dispatch(
                updateAdminEigentuemerwechselItemStatusById({
                  id: itemId,
                  status: "accepted",
                }),
              );
            }
          }}
        />
      ) : null}
    </div>
  );
};

export default Mags;
